import { BaseStateModel, NotificationModel } from "Redux/Models";

export class NotificationState extends BaseStateModel {
  public isLoading: boolean = false;
  public notifications: Array<NotificationModel> = [];
}